GatorSurvey.app.directive("gsLoader", ['loaderService', function (loaderService) {
    return {
        restrict: 'AE',       
        templateUrl:  'Assets/Scripts/App/Directives/Templates/gsLoader.html',
        controller: [
            '$scope', function ($scope) {
                $scope.ShowHide = false;
                var changeState = function(state) {
                    $scope.ShowHide = state;
                };
                loaderService.registerObserver(changeState);
            }
        ]
    }; 
}]);